import './CSS_ke_log/CssForFIVEJS.css'
const Handryer = () =>{
return(<div>
    <p id="pncilwala">हैंड ड्रायर्स COVID-19 से बचाव <span style={{color: "red"}}>नहीं</span> करेंगे। अपने आप को बचाने के लिए, आपको बार-बार अपने हाथों को अल्कोहल-आधारित हैंड सैनिटाइज़र से साफ करना चाहिए या उन्हें साबुन और पानी से धोना चाहिए। एक बार जब आपके हाथ साफ हो जाएं, तो आपको तौलिये या गर्म हवा के ड्रायर का उपयोग करके उन्हें अच्छी तरह से सुखा लेना चाहिए।</p>
</div>);
}

export default Handryer;